/**
 * Ánh xạ thông báo lỗi thô từ API sang chuỗi đã locale (qua `t`).
 * Chuỗi không khớp mẫu phổ biến vẫn trả nguyên bản (thường là tiếng Anh từ server).
 */
export function formatApiErrorMessage(raw, t) {
  const m = String(raw || '').trim();
  if (!m) return t('errors.apiFallback');
  const low = m.toLowerCase();
  if (low === 'unauthorized' || m === 'HTTP 401' || /\b401\b/.test(m)) return t('errors.unauthorized');
  if (low === 'forbidden' || m === 'HTTP 403' || /\b403\b/.test(m)) return t('errors.forbidden');
  if (low.includes('not found') || m === 'HTTP 404' || /\b404\b/.test(m)) return t('errors.notFound');
  if (low === 'bad request' || m === 'HTTP 400' || /\b400\b/.test(m)) return t('errors.badRequest');
  if (low.includes('timeout') || low.includes('network') || low.includes('failed to fetch'))
    return t('errors.network');
  return m;
}
